import React, { useEffect, useState } from "react";
import { message, Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getAuth } from "firebase/auth";
import Spinner from "../common/spinner";

const UploadCertificate = ({ onNewCertificateUrl, onFileName, riderId }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const storage = getStorage();
    const [loading, setLoading] = useState(false);

    useEffect(() => { }, []);

    const props = {
        showUploadList: false,
        beforeUpload: () => false, // prevents auto upload
        onChange: (info) => {
            if (info.file.status !== "uploading") {
                UploadCertificate(info);
            }
        },
    };

    function unixTimestamp(date = Date.now()) {
        return Math.floor(date / 1000);
    }

    const UploadCertificate = async (info) => {
        setLoading(true);
        const timestamp = unixTimestamp();
        const fileType = `${info.file.type}`.split("/");
        const imageUrl =
            "ncc/" +
            riderId + "/" +
            timestamp + "." +
            fileType[1];
        const metadata = {
            contentType: info.file.type,
        };
        try {
            const imageFile = info.file;
            const storageRef = ref(storage, imageUrl);
            uploadBytes(storageRef, imageFile, metadata).then(() => {
                messageApi.open({
                    type: "success",
                    content: "ِYour file has been uploaded successfully",
                });
                onNewCertificateUrl(imageUrl);
                onFileName(timestamp + "." + fileType[1])
                setLoading(false);
            });
        } catch (error) {
            messageApi.open({
                type: "error",
                content: error,
            });
            setLoading(false);
        }
    };

    return (
        <>
            {contextHolder}
            {loading && <Spinner />}
            <Upload {...props} maxCount={1} accept=".pdf, .png, .jpg, .jpeg">
                <Button style={{ height: 40, marginTop: 6 }} icon={<UploadOutlined />}>Upload</Button>
            </Upload>
        </>
    );
};

export default UploadCertificate;
